<template>
  <div class="row">
    <div class="col-md-12">
      <form method="get" action="/" class="form-horizontal">
        <fieldset>
          <div class="form-group">
            <label class="col-sm-8 control-label">Customer</label>
            <div class="col-sm-4">
              <el-select
                v-model="dataUpload.customerID"
                ref="customerID"
                placeholder="Select Customer"
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="`${item.thName} / ${item.enName}`"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="form-group">
            <label class="col-sm-2 control-label">File</label>
            <div class="col-sm-10">
              <el-upload
                class="upload-demo"
                ref="upload"
                accept=".csv"
                :headers="uploadHeaders"
                :data="dataUpload"
                :action="uploadURI"
                :auto-upload="false"
                :on-success="handleUploadSuccess"
                :on-error="handleUploadError"
                :before-upload="beforeUpload"
              >
                <p-button
                  slot="trigger"
                  size="small"
                  type="primary"
                  :disabled="!dataUpload.customerID ? true : false"
                >select file</p-button>
                <p-button
                  style="margin-left: 10px;"
                  size="small"
                  type="success"
                  :disabled="!dataUpload.customerID ? true : false"
                  @click="submitUpload"
                >upload to server</p-button>
                <div class="el-upload__tip" slot="tip">csv file.</div>
              </el-upload>
            </div>
          </div>
        </fieldset>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from "vue"
import * as _apiCustomer from "@/api/customer"
import {mapGetters} from 'vuex'
import {
  Upload,
  Loading
} from "element-ui";

Vue.use(Loading)

export default {
  components: {
    [Upload.name]: Upload,
  },
  data: ()=> ({
    dataUpload: {
      customerID: '',
    },
    options: [],
    uploadHeaders: {
      Authorization: ''
    },
    uploadURI: '',
    loading: {}
  }),
  computed: {
    ...mapGetters({
      currentUser: "$_user/currentUser"
    }),
  },
  created () {
    this.getAllCustomer()
  },
  mounted () {
    // TODO:
    this.uploadURI = process.env.VUE_APP_ROOT_API || 'http://127.0.0.1:5005';
    this.uploadURI = this.uploadURI + '/api/w/masterdata'
  },
  methods: {
    getAllCustomer(){
      _apiCustomer.getAll()
      .then(response => {
        this.options = response.data
      })
      .catch(error => {
        this.$notify({
          message: error.response.data.message || 'Unsuccessfully',
          type: 'danger'
        })
      });
    },
    handleUploadSuccess(response, file, fileList) {
      this.closeWrapperFullScreen()
      alert('Uploaded Successfully')
      // this.$notify({
      //   message: 'Successfully',
      //   type: 'success'
      // })
    },
    handleUploadError(err, file, fileList) {
      this.closeWrapperFullScreen()
      alert('Unsuccessfully,' + JSON.parse(err.message).message)
      // this.$notify({
      //   message: JSON.parse(err.message).message || 'Unsuccessfully',
      //   type: 'danger'
      // })
    },
    beforeUpload(file) {
      var validExts = new Array(
        'text/comma-separated-values',
        'text/csv',
        'application/csv',
        'application/excel',
        'application/vnd.ms-excel',
        'application/vnd.msexcel'
        );
      const isCSV = validExts.indexOf(file.type) < 0 ? false : true

      // const isCSV = file.type === 'text/csv'
      const isLt3M = file.size / 1024 / 1024 / 1024 < 3;
      if (!isCSV) {
        alert('File must be CSV format!, '+file.type)
        // this.$notify({
        //   message: 'File must be CSV format!, '+file.type,
        //   type: 'danger'
        // })
      }
      if (!isLt3M) {
        alert('File size can not exceed 3MB!, '+file.size)
        // this.$notify({
        //   message: 'File size can not exceed 3MB!, '+file.size,
        //   type: 'danger'
        // })
      }

// TODO:
      // Set Token
      let token = localStorage.getItem('token')
      this.uploadHeaders.Authorization = "Bearer " + token
      this.openWrapperFullScreen()
      return isCSV && isLt3M;
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    openWrapperFullScreen() {
      this.loading = this.$loading({
        lock: true,
        text: 'Processing',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.9)'
      });
    },
    closeWrapperFullScreen() {
      this.loading.close()
    }
  }
}
</script>
